export default "__VITE_ASSET__Bhy8ckuy__"